/*
 * @Auther: 罗耀祖
 * @Date: 2022-02-11 16:18:42
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-03-23 09:58:46
 * @name: 用户-忘记重置密码
 * @Description: 用户-忘记重置密码
 * @FilePath: \project\src\module\user\validator\forgetPwd.js
 * @Author: desktop
 */
export const validator = [
  {
    key: 'mobile',
    description: '手机号',
    required: true,
    required_message: '手机号为必填项',
    require_toast: true,
    match: (e) => {
      if (!e) {
        return '请输入手机号';
      } else if (!(e.length === 11 && /^\d+$/.test(e))) {
        return '手机号格式错误';
      } else {
        return '';
      }
    },
    match_toast: true,
  },
  {
    key: 'password',
    description: '密码',
    required: true,
    required_message: '密码为必填项',
    require_toast: true,
    match: (e) => {
      if (!e) {
        return '请输入密码';
      } else {
        return '';
      }
    },
    match_toast: true,
  },
  {
    key: 'verify',
    description: '手机验证码',
    required: true,
    required_message: '手机验证码为必填项',
    require_toast: true,
    match: (e) => {
      if (!e) {
        return '请输入手机验证码';
      } else {
        return '';
      }
    },
    match_toast: true,
  },
]